<template>
  <div class="page-container appstore_wrap">
    <div>
      <div class="section rights-require-wrap bgf">
        <div class="w1200">
          <div class="hd">
            <h2>注册已完成等待审核</h2>
          </div>
          <div class="bd">
            <div class="tabs-wrap">
              <div class="tab-content">
                <div class="panel-box">
                  <table class="table-4-col">
                    <thead>
                      <th id=""></th>
                    </thead>
                    <tbody>
                      <template v-for="(item, key) in info">
                        <tr :key="key">
                          <td class="name col-1">
                            <div>{{ item.label }}</div>
                          </td>
                          <td class="col-2">
                            <div>
                              <span>{{ item.value }}</span>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="hd">
            <el-button
              type="primary"
              class="next_btn mt30"
              v-on:click="handleLogo"
            >
              登录
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditStore',
  props: {
    endObj: Object
  },
  data() {
    return {
      info: {}
    };
  },
  methods: {
    handleLogo() {
      this.$router.push({
        name: 'login'
      });
    }
  },
  created() {
    if (this.endObj) {
      this.info = [
        {
          label: '商店名称',
          value: this.endObj.marketName
        },
        {
          label: '管理员账号',
          value: 'admin@' + this.endObj.domain
        }
      ]
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.mt30 {
  margin-top: 30px;
}
ol,
ul,
dl {
  margin: 0;
}
.dn-btn {
  margin: 0;
  height: 32px;
  padding: 0 24px;
  font-size: 12px;
  line-height: 30px;
  border-width: 1px;
}

.bgf {
  background: #fff;
}
.rights-require-wrap {
  padding-top: 120px;
  .tabs-wrap {
    margin: 0 10px;
    .tab-nav {
      width: 205px;
      margin: 0 auto 50px;
      *zoom: 1;
      &:before {
        content: "";
        display: table;
      }
      .active {
        color: #fff;
        background: #409eff;
        border-color: #409eff;
        z-index: 2;
      }
      a {
        position: relative;
        float: left;
        line-height: 36px;
        width: 100px;
        text-align: center;
        text-decoration: none;
        font-size: 14px;
        color: #373d41;
        background: #fff;
        border: 1px solid #d7d8d9;
      }
    }
  }

  .panel-box {
    background: #fff;
    border: 1px solid #d7d8d9;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    table {
      width: 100%;
      td,
      th {
        width: 25%;
      }
      tr:hover {
        background: #f8f8f9;
      }
      th {
        position: relative;
        font-size: 18px;
        color: #666;
        text-align: center;
        font-weight: 400;
        border-bottom: 1px solid #f8f8f9;
        box-sizing: border-box;
        & > div {
          width: 100%;
          height: 100px;
          line-height: 130px;
          box-sizing: border-box;
          position: relative;
        }
        .icon {
          position: absolute;
          top: -18px;
          left: 50%;
          transform: translateX(-50%);
          width: 64px;
          height: 64px;
        }
      }
      .name {
        text-align: left;
      }
      td {
        text-align: center;
        font-size: 14px;
        color: #373d41;
        border-bottom: 1px solid #f8f8f9;
        box-sizing: border-box;
        & > div {
          width: 100%;
          height: 68px;
          line-height: 68px;
          text-align: center;
          box-sizing: border-box;
          position: relative;
          img {
            width: 26px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .more-info-btn {
      display: none;
      padding: 20px 0;
      font-size: 14px;
      color: #409eff;
      text-align: center;
      cursor: pointer;
    }
  }
  .hidden {
    display: none;
  }
}
.section {
  padding: 80px 0;
  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .hd {
    margin-bottom: 40px;
    text-align: center;
    h2 {
      font-size: 24px;
      color: #373d41;
    }
  }
  .bd {
    position: relative;
    *zoom: 1;
    &:before {
      content: "";
      display: table;
    }
    &:after {
      clear: both;
    }
  }
}
.plan-box {
  position: relative;
  margin: 0 10px;
  background: #fff;
  border: 1px solid #d7d8d9;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  .item {
    &:hover {
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    }
    border-bottom: 1px solid #d5d5d6;
    .active {
      background: #409eff;
      h3,
      p {
        color: #fff;
      }
      .join-btn {
        color: #fff;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
    dt {
      position: relative;
      height: 96px;
      cursor: pointer;
      h3 {
        font-size: 18px;
        color: #373d41;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0;
      }
      p {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .head-info {
        padding: 25px 200px 0 100px;
      }
      .join-btn {
        position: absolute;
        right: 40px;
        top: 30px;
        border: 1px solid #409eff;
        color: #409eff;
        &:hover {
          color: #fff;
          background: #409eff;
          border-color: #409eff;
        }
      }
      .icon {
        position: absolute;
        left: 25px;
        top: 23px;
        width: 50px;
      }
      .def {
        display: block;
      }
      .hover {
        display: none;
      }
    }
    dd {
      padding: 30px 100px;
      background: #f5f5f6;
      .intr {
        margin-bottom: 5px;
        font-size: 14px;
        color: #606468;
      }
      .more {
        margin-bottom: 20px;
      }
      span {
        font-weight: 700;
        font-size: 14px;
        color: #5f6367;
      }
      li {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/auditStore.vue